var WidgetEventFormController = require('./WidgetEventFormController.js').default;

function WidgetEventFormDirective($parse) {
	return {
		restrict: 'E',
		scope: {
			'model': '=ngModel',
			'columns': '=?',
			'available': '=',
			'errorCondition': '=',
			'availableDrilldown': '=',
			'availableDragEvent': '=',
			'customDrillDownQueryHelp': '=',
			'hideBrowser': '='
		},
		controller: WidgetEventFormController,
		require: 'ngModel',
		controllerAs: 'vm',
		templateUrl: '/package/system/dashboard/view.WidgetEventForm.html',
		link: function(scope, el, attr, ctrl) {
			function formatter(modelValue) {
				if(!modelValue) {
					return;
				}

				scope.vm.originalValue = modelValue;

				if(!!modelValue.click) {
					scope.vm.setEvent('click', modelValue.click);
				}
				if(!!modelValue.drag) {
					scope.vm.setEvent('drag', modelValue.drag);
				}
				return modelValue;
			}

			ctrl.$formatters.push(formatter);


			scope.$watch('model', formatter, true);



			scope.vm.ngModelController = ctrl;
		}
	}
}

module.exports = WidgetEventFormDirective;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetEventFormDirective.js